import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

interface LanguageToggleProps {
  className?: string;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ className = '' }) => {
  const { language, setLanguage } = useTranslation();

  const toggleLanguage = () => {
    setLanguage(language === 'ru' ? 'en' : 'ru');
  };

  const isRu = language === 'ru';

  return (
    <button
      onClick={toggleLanguage}
      className={`
        flex items-center justify-center w-12 h-8 rounded-md 
        bg-gray-700 hover:bg-gray-600 text-gray-300 hover:text-white 
        transition-colors duration-200 text-xs font-bold
        ${className}
      `}
      title={isRu ? 'Сейчас: русский. Нажмите для English' : 'Current: English. Click for русский'}
      aria-label={isRu ? 'Switch to English' : 'Переключить на русский'}
    >
      {isRu ? 'RU' : 'EN'}
    </button>
  );
};

export default LanguageToggle;
